<template>
<section>
  <b-row class="mb-2">
    <b-col cols="4">
      <b-form-group label-cols="4" label-align="right" label="Currency">
        <b-form-select v-model="quote.currencyTypeId">
          <option v-for="(select, index) in sortSelect(currencies)" :key="index" :value="select.id">{{ select.name }}
          </option>
        </b-form-select>
      </b-form-group>
    </b-col>
    <b-col cols="3">
      <b-form-group label-cols="7" label-align="right" label="Exch. Rate">
        <b-input-group :prepend="formattedProps.currencySymbol ? formattedProps.currencySymbol : ''" size="sm">
          <b-form-input v-model="quote.exchangeRate" />
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col cols="2">
      <b-form-group label-align="right">
        <b-form-checkbox v-model="quote.isTaxable"  >
          Taxable
        </b-form-checkbox>
      </b-form-group>
    </b-col>
    <b-col cols="3">
      <b-form-group label-cols="5" label-align="right" label="Tax Rate">
        <b-form-input v-model="quote.taxRate" @input="onChangeTaxRate" />
      </b-form-group>
    </b-col>
  </b-row>
  <b-row>
    <label class="col-sm-4 col-form-label text-center">Customer Amount</label>
    <label class="col-sm-4 col-form-label text-center">Converted Amounts</label>
    <label class="col-sm-4 col-form-label text-center">Cost and Margin</label>
    <!--<label class="col-sm-1 col-form-label"></label>-->
  </b-row>
  <b-row>
    <b-col cols="4">
      <b-form-group label-cols="4" label-align="right" label="Sub Total">
        <b-input-group :prepend="formattedProps.currencySymbol" size="sm">
          <b-form-input disabled :value="formattedProps.subTotal" />
        </b-input-group>
      </b-form-group>
      <b-form-group label-cols="4" label-align="right" label="Charges">
        <b-input-group :prepend="formattedProps.currencySymbol" size="sm">
          <b-form-input disabled :value="formattedProps.totalCharges" />
        </b-input-group>
      </b-form-group>
      <b-form-group label-cols="4" label-align="right" label="Tax">
        <b-input-group :prepend="formattedProps.currencySymbol" size="sm">
          <b-form-input disabled :value="formattedProps.tax" />
        </b-input-group>
      </b-form-group>
      <b-form-group label-cols="4" label-align="right" label="Total">
        <b-input-group :prepend="formattedProps.currencySymbol" size="sm">
          <b-form-input disabled :value="formattedProps.total" />
        </b-input-group>
      </b-form-group>
      <b-form-group label-cols="4" label-align="right" label="Credit" v-if="showCredit">
        <b-input-group :prepend="formattedProps.currencySymbol" size="sm">
          <b-form-input disabled :value="formattedProps.credit" />
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col cols="4">
      <b-form-group label-cols="1" label-align="right">
        <b-input-group prepend="$" size="sm">
          <b-form-input disabled :value="formattedProps.subTotalConverted" />
        </b-input-group>
      </b-form-group>
      <b-form-group label-cols="1" label-align="right">
        <b-input-group prepend="$" size="sm">
          <b-form-input disabled :value="formattedProps.totalChargesConverted" />
        </b-input-group>
      </b-form-group>
      <b-form-group label-cols="1" label-align="right">
        <b-input-group prepend="$" size="sm">
          <b-form-input disabled :value="formattedProps.tax" />
        </b-input-group>
      </b-form-group>
      <b-form-group label-cols="1" label-align="right">
        <b-input-group prepend="$" size="sm">
          <b-form-input disabled :value="formattedProps.totalConverted" />
        </b-input-group>
      </b-form-group>
      <b-form-group label-cols="1" label-align="right" v-if="showCredit">
        <b-input-group prepend="$" size="sm">
          <b-form-input disabled value="0.00" />
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col cols="4">
      <!--<b-form-group label="Cost" class="mb-2">
        <b-input-group prepend="$" size="sm">
          <b-form-input disabled :value="formattedProps.totalLineCost" @change="formatNumber"/>
        </b-input-group>
      </b-form-group>-->
      <b-form-group label-cols="4" label-align="right" label="Cost">
        <b-input-group prepend="$" size="sm">
          <b-form-input disabled :value="formattedProps.totalLineCostConverted" @change="formatNumber"/>
        </b-input-group>
      </b-form-group>
      <b-form-group label-cols="4" label-align="right" label="Expenses">
        <b-input-group prepend="$" size="sm">
          <b-form-input disabled :value="formattedProps.totalChargesCostConverted" />
        </b-input-group>
      </b-form-group>
      <b-form-group label-cols="4" label-align="right" label="Total Cost">
        <b-input-group prepend="$" size="sm">
          <b-form-input disabled :value="TCost"/>
        </b-input-group>
      </b-form-group>
      <b-form-group label-cols="4" label="Est. Profit" label-align="right" v-if="!isPurchaseOrderView">
        <!--<b-row>
          <b-col sm="7">
          <b-input-group prepend="$" size="sm">
            <b-form-input disabled :value="formattedProps.grossProfit" @change="formatNumber"/>
          </b-input-group>
          </b-col>
          <b-col sm="5">
          <b-input-group append="%" size="sm">
            <b-form-input disabled :value="formattedProps.gpMargin ? (formattedProps.gpMargin) + '%' : null" @change="formatNumber"/>
          </b-input-group>
          </b-col>
        </b-row>-->
        <!-- <div class="input-group input-group-sm mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text">$</span>
          </div> -->
          <b-input-group prepend="$" size="sm">
            <b-form-input disabled :value="formattedProps.estimatedProfit" v-if="isSalesOrderView" />
            <b-form-input disabled :value="formattedProps.grossProfit" v-else />
          </b-input-group>
          
          <!-- <div class="input-group-append">
            <span class="input-group-text" v-if="isSalesOrderView">{{(formattedProps.estimatedMargin ? (formattedProps.estimatedMargin) : 0 )}} %</span>
            <span class="input-group-text" v-else>{{(formattedProps.gpMargin ? (formattedProps.gpMargin) : 0 )}} %</span>
          </div>
        </div> -->
      </b-form-group>
      <b-form-group label-cols="4" label="Est. Margin" label-align="right" v-if="!isPurchaseOrderView">
        <b-input-group prepend="%" size="sm">
          <b-form-input disabled :value="(formattedProps.estimatedMargin ? (formattedProps.estimatedMargin) : 0 )" v-if="isSalesOrderView" />
          <b-form-input disabled :value="(formattedProps.gpMargin ? (formattedProps.gpMargin) : 0 )" @change="formatNumber" v-else />
        </b-input-group>
      </b-form-group>

    </b-col>
    <!--<b-col>
      <b-alert variant="success" class="mt-1 text-center" show size="sm" v-if="isPaid"><strong>PAID</strong></b-alert>
    </b-col>-->
  </b-row>
</section>
</template>

<script>

import debounce from 'lodash/debounce';
import { mapActions, mapGetters } from 'vuex';

const DEBOUNCE_TIME = 750;

export default {
  props: {
    quote: {
      type: Object,
      default: () => {}
    },
    isPurchaseOrderView: {
      type: Boolean,
      default: false
    },
    isSalesOrderView: {
      type: Boolean,
      default: false
    },
    isPaid: {
      type: Boolean,
      default: false
    },
    showCredit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      convertProps: [
        'subTotalConverted',
        'totalChargesConverted',
        'totalChargesTaxableConverted',
        'totalConverted'
      ],
      origProps: [
        'subTotal',
        'totalCharges',
        'totalChargesTaxable',
        'total'
      ],
      addtlProps: [
        'tax',
        'totalLineCostConverted',
        'totalChargesCostConverted',
        'grossProfit',
        'estimatedProfit'
      ],
      formattedProps: {},
      format: 'en-US',
      precision: { minimumFractionDigits: 2 }
    }
  },
  computed: {
    ...mapGetters('lookup', ['currencies']),
    // currencySymbol() {
    //   let currency = this.currencies.find(x => x.id == this.quote.currencyTypeId);

    //   return (currency) ? currency.symbol : '-';
    // }

    TCost(){
      if((this.formattedProps.totalChargesCostConverted || this.formattedProps.totalLineCost)) {
        let totalLineCost = this.formattedProps.totalLineCost;
        let totalChargesCostConverted = this.formattedProps.totalChargesCostConverted;

        if(typeof totalLineCost != 'number' && totalLineCost.indexOf(',') > -1){
          totalLineCost = Number(totalLineCost.replace(/,/g, ''));
        }else{
          totalLineCost = Number(totalLineCost);
        }

        if(typeof totalChargesCostConverted != 'number' && totalChargesCostConverted.indexOf(',') > -1){
          totalChargesCostConverted = Number(totalChargesCostConverted.replace(/,/g, ''));
        }else{
          totalChargesCostConverted = Number(totalChargesCostConverted);
        }

        let total_cost = totalLineCost + totalChargesCostConverted;
        return this.formatMoney(total_cost);
      }else {
        return null
      }
    }
  },
  mounted() {
  },
  methods: {
    ...mapActions('quotes', ['updateTotals']),
    onChangeTaxRate() {
      this.quote.taxRate = this.quote.taxRate == '' || this.quote.taxRate == undefined || this.quote.taxRate == null ? 0 : this.quote.taxRate;
    },
    formatNumber(value, event) {
      return Number(value).toLocaleString();
    },
    formatMoney(val) {
      try {
        var str = Number(val || 0).toFixed(2).toString().split('.');
        if (str[0].length >= 3) {
          str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
        }
        if (str[1]) {
          if (str[1].length < 2) {
            while (str[1].length < 2) { str[1] = str[1] + "0"; }
          } else if (str[1].length > 2) {
            str[1] = str[1].substring(0, 2)
          }
        }
        return str.join('.');
      } catch {
        return val;
      }
    },
    initializeAndFormat() {
      this.formattedProps = { ...this.quote };
      this.formattedProps.currencySymbol = this.formattedProps.currencySymbol ? this.formattedProps.currencySymbol : '$'
      var propsArr = this.origProps.concat(this.convertProps, this.addtlProps);

      propsArr.forEach(prop => {
        if (this.formattedProps[prop])
          this.formattedProps[prop] = this.formatMoney(this.formattedProps[prop]);
      });

      console.log(this.quote, this.formattedProps, "Props")
    },
    formatConverted() {
      this.convertProps.forEach(prop => {
        if (this.formattedProps[prop])
          this.formattedProps[prop] = this.formatMoney(this.quote[prop]);
      });
    },
    onShippingChange: debounce (async function() {
      if (! this.quote.shippingCharge) {
         this.quote.shippingCharge = 0;
      }
      let body = { shipping: this.quote.shippingCharge, noChargeShipping: this.quote.noChargeShipping };
      var result = await this.getTotals(body);
      this.$emit('updateTotal',result);

    },DEBOUNCE_TIME),
    async getTotals(body) {
      const result = await this.updateTotals([this.quote.id, body]);
      return result;
    }
  },
  watch: {
    quote() {
      this.initializeAndFormat();
    },
    'quote.exchangeRate'() {
      for (let i = 0; i < this.convertProps.length; i++) {
        let val = (typeof this.quote[this.origProps[i]] === 'string')
        ? parseFloat(this.quote[this.origProps[i]].replace(',',''))
        : this.quote[this.origProps[i]];

        this.quote[this.convertProps[i]] = (val * this.quote.exchangeRate);
        this.formattedProps[this.convertProps[i]] = this.formatMoney((val * this.quote.exchangeRate));
      }
    }
  }
};
</script>